<template>
  <div class="normap">
    <div v-if='!tit'>/</div>
    <a-popover :content="tit" v-else>
      <span class="norTie">{{ tit }}</span>
    </a-popover>
  </div>
</template>
<script>
export default {
  props: {
    tit: {
      type: String,
      default() {
        return ''
      }
    }
  }
}
</script>
<style scoped>
.norTie {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
}
</style>